<template>
    <div class="bordas legenda-content"> 
        <button type="button" class="btn btn-success btn-sm btn-legenda font-weight-bold" @click="filtraLivres()"> 
            Livres: {{livres}}
        </button>
        
        <button type="button" class="btn btn-secondary btn-sm btn-legenda font-weight-bold" @click="filtraOcupados()"> 
            Ocupados: {{ocupados}}
        </button>
        
        <button type="button" class="btn btn-danger btn-sm btn-legenda font-weight-bold" @click="filtraImpedidos()"> 
            Impedidos: {{impedidos}}
        </button>
        
        <button type="button" class="btn btn-info bg-azul btn-sm btn-legenda font-weight-bold" @click="filtraCedidos()"> 
            Cedidos: {{cedidos}}
        </button>
        
        <button type="button" class="btn bg-laranja btn-sm btn-legenda font-weight-bold text-white" @click="filtraReservados()"> 
            Reservados: {{reservados}}
        </button>
    </div>   
</template>

<script>
export default {
    computed: {
         listagemMapaLeitos () {
            return this.$store.getters['leitos/getListagemMapaLeitos']
        },
        listagemFiltradaStatus () {
            return this.$store.getters['leitos/getListagemFiltradaStatus']
        },
        enfermariaSelecionada () {
            return this.$store.getters['filtro/getEnfermariaSelecionada']
        },
        info () {
            let info = this.listagemMapaLeitos.dados
            if (this.enfermariaSelecionada != '') info = info.filter(i => i.leitoNomeEnfermaria == this.enfermariaSelecionada)
            return info
        },
        livres () {
            // status 0=livre, 1=ocupado, 2=impedido, 3=cedido, 4 = regulado 
            let total = this.info.filter(i => i.leitoStatus == 0)
            return total.length
        },
        ocupados () {
            let total = this.info.filter(i => i.leitoStatus == 1)
            return total.length
        },
        impedidos () {
            let total = this.info.filter(i => i.leitoStatus == 2)
            return total.length
        },
        cedidos () {
            let total = this.info.filter(i => i.leitoStatus == 3 || i.leitoStatus == 4)
            return total.length
        },
        reservados () {
            let total = this.info.filter(i => i.leitoStatus == 5)
            return total.length
        }
    },
    methods: {
        filtraLivres () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 0 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 0)
        },
        filtraOcupados () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 1 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 1)
        },
        filtraImpedidos () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 2 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 2)
        },
        filtraCedidos () {
            this.$store.commit('transferir/setLeitoTransferencia', null)
            
            this.listagemFiltradaStatus == 3 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 3)
        },
        filtraReservados () {
            this.$store.commit('transferir/setLeitoTransferencia', null)
            
            this.listagemFiltradaStatus == 13 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 13)
        },
    }
}
</script>

<style>
    .legenda-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
    }

    .btn-legenda {
        margin: 6px 6px 6px 6px;
        min-width: 125px;
    }

    @media (min-width: 1154px) {
        .legenda-content {
            flex-direction: column;
        }

        .btn-legenda {
            margin: 0 0 10px 0;
        }
    }

</style>

